import { render, staticRenderFns } from "./kdxStatusText.g.vue?vue&type=template&id=0cad821d&scoped=true"
import script from "./kdxStatusText.g.vue?vue&type=script&lang=js"
export * from "./kdxStatusText.g.vue?vue&type=script&lang=js"
import style0 from "./kdxStatusText.g.vue?vue&type=style&index=0&id=0cad821d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad821d",
  null
  
)

export default component.exports